//import React from 'react';

import React, { useState, useEffect } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Checkbox from "@material-ui/core/Checkbox";

import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton";
import ShareIcon from "@material-ui/icons/Share";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";

import ScrapCheckboxList from "./ScrapCheckboxList";

//import { getDefaultVoices } from "../shared/Voices";
import Container from "@material-ui/core/Container";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";

import PhoneIcon from "@material-ui/icons/Tune";
import FavoriteIcon from "@material-ui/icons/Spellcheck";
import StarIcon from "@material-ui/icons/Star";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function DialogScrapResult(props) {
  const [open, setOpen] = React.useState(false);
  const [tab, setTab] = React.useState(0);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    props.handleScrapFiltered(
      state.Scrap_Description,
      state.Language,
      state.Scrap_Short
    );

    setOpen(false);
  }

  const [state, setState] = React.useState({
    Scrap_Description: [],
    Scrap_Short: [],
    Language: "",
  });

  //  const handleChangeSelect = name =>event=> {

  //    elsee
  //     setState({ ...state, [name]: event.target.value });
  //    }
  // }

  const handleChange = (name) => (event) => {
    setState({ ...state, [name]: event.target.checked });
  };

  const handleChangeText = (name) => (event) => {
    setState({ ...state, [name]: event.target.value });
  };

  function handleScrapFiltered(list, language) {
    //   props.handleScrapFiltered(list);
    setState({ ...state, ["Scrap_Description"]: list, ["Language"]: language });
  }

  function handleScrapShortFiltered(list, language) {
    //   props.handleScrapFiltered(list);
    setState({ ...state, ["Scrap_Short"]: list, ["Language"]: language });
  }

  function handleTabChange(event, newValue) {
    // setState({
    //   ...state,
    //   tab: newValue,
    // });
    setTab(newValue);
    //alert(newValue);
    //alert(tab);
  }

  return (
    <div>
      <div
        id="scrap-results-dialog"
        onClick={handleClickOpen}
      ></div>

      {/* <IconButton
        id="scrap-results-dialog"
        aria-label="Share"
        onClick={handleClickOpen}
      >
        <ShareIcon />
      </IconButton> */}

      <Dialog
        fullWidth="xl"
        maxWidth="xl"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Scrap Result"}</DialogTitle>
        <DialogContent>
          <Tabs
            id="tab"
            value={state.tab}
            onChange={handleTabChange}
            variant="fullWidth"
            indicatorColor="primary"
            textColor="secondary"
            aria-label="icon label tabs example"
          >
            <Tab icon={<PhoneIcon />} />
            <Tab icon={<FavoriteIcon />} />
            <Tab icon={<StarIcon />} />
          </Tabs>

          {tab === 0 && (
            <TabContainer>
              <Container fixed>
                <ScrapCheckboxList
                  handleScrapShortFiltered={handleScrapShortFiltered}
                  list={props.short}
                  type={"short"}
                  scrape_site={"contexo"}
                ></ScrapCheckboxList>
                <ScrapCheckboxList
                  handleScrapFiltered={handleScrapFiltered}
                  list={props.description}
                  type={"description"}
                  scrape_site={"contexo"}
                ></ScrapCheckboxList>
              </Container>
            </TabContainer>
          )}
          {tab === 1 && (
            <TabContainer>
              <Container fixed>
                <ScrapCheckboxList
                  handleScrapShortFiltered={handleScrapShortFiltered}
                  list={props.short1}
                  type={"short"}
                  scrape_site={"lingoloia"}
                ></ScrapCheckboxList>
                <div>----------------------</div>
                <ScrapCheckboxList
                  handleScrapFiltered={handleScrapFiltered}
                  list={props.description1}
                  type={"description"}
                  scrape_site={"lingoloia"}
                ></ScrapCheckboxList>
              </Container>
            </TabContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Disagree
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
